import axios from '../../../axios';
import CVUploaderSettingsRequest from '../types/CVUploaderSettingsRequest';

const settingsUrl = '/recruitersearch/api/cv-uploader-settings';
// const emailAccounts = '/emailingapp/api/recruiter-smtp-accounts';

export const saveCVUploaderSettings = (cvUploaderSettingsRequest: CVUploaderSettingsRequest) =>
  axios.post(`${settingsUrl}`, cvUploaderSettingsRequest);
export const getCVUploaderSettings = () => axios.get(`${settingsUrl}`);
